export default __webpack_public_path__ + "static/SR India - Non GMO - Statement-2ec77040fb260ca426a9173bbe3f83a5.pdf";